import { Tooltip, TooltipContent, TooltipTrigger } from "@components/ui/tooltip"
import { useAccount, useGetEnergyImpactQuery } from "@apis/accounts/useAccounts"
import { getIcon } from "./iconParser"
import { useGetUtilityQuery } from "@apis/utilities/useUtilities"
import { renderSkeletonGroups } from "@utils/renderSkeletonGroups"

interface IEnergyImpactProps {
  account_id: string
}

export const EnergyImpact = ({ account_id }: IEnergyImpactProps) => {
  const getAccountQuery = useAccount(account_id)
  const getEnergyImpactQuery = useGetEnergyImpactQuery(account_id)
  const getUtilityQuery = useGetUtilityQuery(
    getAccountQuery.data?.market.utility_code,
  )

  if (getAccountQuery.isPending || getEnergyImpactQuery.isPending) {
    return (
      <div className="tw:flex tw:w-full tw:flex-col tw:gap-1">
        {renderSkeletonGroups([
          { count: 1, height: "tw:h-6" },
          { count: 4, height: "tw:h-5" },
        ])}
      </div>
    )
  }

  if (getAccountQuery.isError || getEnergyImpactQuery.isError) {
    return <div className="tw:text-red-500">Error loading Energy Impact.</div>
  }

  return (
    <div className="tw:flex tw:flex-col tw:gap-1">
      <h2 className="tw:mb-0 tw:text-xs tw:font-semibold">
        Your <b>Avg Yearly Usage</b> of{" "}
        {getAccountQuery.data?.avg_annual_usage || 0}{" "}
        {getUtilityQuery.data?.native_unit_of_measure} offsets as much carbon
        as..
      </h2>

      <div className="tw:flex tw:flex-col tw:gap-0">
        {getEnergyImpactQuery.data?.map((impact, index) => {
          return (
            <Tooltip key={`${impact.first_unit}-${index}`}>
              <TooltipTrigger>
                <div className="tw:flex tw:cursor-default tw:gap-2 tw:align-baseline tw:text-sm">
                  {getIcon(impact.icon)}
                  <p className="tw:m-0 tw:p-1">
                    {impact.first_amount} {impact.first_unit}
                  </p>
                </div>
              </TooltipTrigger>
              {impact.second_amount && (
                <TooltipContent side="left">
                  (
                  <span>
                    {impact.second_amount} {impact.second_unit}
                  </span>
                  )
                </TooltipContent>
              )}
            </Tooltip>
          )
        })}
      </div>
    </div>
  )
}
